/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function CertificationsSection() {
  return (
    <MKBox
      bgColor="#343434"
      borderRadius="xl"
      shadow="lg"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      mt={{ xs: 10, sm: 10, md: 10 }}
      mb={{ xs: 10, sm: 10, md: 10 }}
      mx={3}
    >
      <MKBox
        variant="gradient"
        bgColor="info"
        coloredShadow="secondary"
        borderRadius="lg"
        p={2}
        mx={2}
        mt={-3}
      >
        <MKTypography
          variant="h1"
          color="white"
          sx={{ overflowWrap: "break-word", textAlign: "center" }}
        >
          Certifications
        </MKTypography>
      </MKBox>
      <MKBox p={3}>
        <MKTypography variant="h5" color="white">
          CPA – C++ Certified Associate Programmer
        </MKTypography>
        <MKTypography variant="body2" color="white" mb={3} ml={2}>
          C++ Institute – Issued March 2025
        </MKTypography>
        <MKTypography variant="h5" color="white">
          CPE – C++ Certified Entry-Level Programmer
        </MKTypography>
        <MKTypography variant="body2" color="white" mb={3} ml={2}>
          C++ Institute – Issued May 2024
        </MKTypography>
      </MKBox>
    </MKBox>
  );
}

export default CertificationsSection;
